module.exports = __webpack_public_path__ + "img/takeaway-logo.c5352908.png";